import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    current: {},
    currentLoading: false,
    listForCompetition: [],
    listForCompetitionLoading: false
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setListForCompetition(state, payload) {
      state.listForCompetition = payload;
    },
    setListForCompetitionLoading(state, payload) {
      state.listForCompetitionLoading = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("divisions");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setCurrentLoading", true);
      let response = await api.get("divisions/byID", { params: { id: id } });
      commit("setCurrent", response.data[0]);
      commit("setCurrentLoading", false);
    },
    async loadForCompetition({ commit }, id) {
      commit("setListForCompetitionLoading", true);
      let response = await api.get("divisions/forCompetition", {
        params: { id: id }
      });
      commit("setListForCompetition", response.data);
      commit("setListForCompetitionLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("divisions", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`divisions`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async addToCompetition({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`divisions/addToCompetition`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      dispatch("loadForCompetition", payload.competitions_id);
      return returnData;
    },
    async removeFromCompetition({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`divisions/removeFromCompetition`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadForCompetition", payload.competitions_id);
      return returnData;
    },
    async delete({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`divisions/delete`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    listForCompetition(state) {
      return state.listForCompetition;
    },
    listForCompetitionLoading(state) {
      return state.listForCompetitionLoading;
    }
  }
};
